import { LogLevel } from '../constants/log.constants';

import { LogEntry } from '../interfaces/log-entry.interface';

import { LogBuffer } from './log-buffer';
import { DateTimeHelper } from './date-time-helper';

export class Logger {

  private logPrefix: string;

  constructor(
    private loggerName: string = '',
    private logLevel: LogLevel = LogLevel.info) {

    this.logPrefix = this.loggerName ? `${this.loggerName}: ` : ``;
  }

  error = (message: string, ...optionalParams: any[]): void => this.logIfEnabled(LogLevel.error, console.error, message, optionalParams);
  warn = (message: string, ...optionalParams: any[]): void => this.logIfEnabled(LogLevel.warn, console.warn, message, optionalParams);
  info = (message: string, ...optionalParams: any[]): void => this.logIfEnabled(LogLevel.info, console.info, message, optionalParams);
  log = (message: string, ...optionalParams: any[]): void => this.logIfEnabled(LogLevel.log, console.log, message, optionalParams);
  debug = (message: string, ...optionalParams: any[]): void => this.logIfEnabled(LogLevel.debug, console.debug, message, optionalParams);

  private logIfEnabled(
    logLevel: LogLevel,
    logFunction: (message?: any, ...optionalParams: any[]) => void,
    message: string,
    optionalParams: any[]): void {

    if (logLevel > this.logLevel) {
      return;
    }

    const logMessage = `${this.logPrefix}${message}`;

    if (optionalParams && optionalParams.length) {
      logFunction(logMessage, ...optionalParams);
    }
    else {
      logFunction(logMessage);
    }

    const logEntry: LogEntry = { timestamp: DateTimeHelper.now().toJSDate(), logLevel, message: logMessage };
    LogBuffer.add(logEntry);
  }
}
